import { useMemo } from 'react';
import useCustomInputWithPresets from 'src/components/TradeForm/hooks/useCustomInputWithPresets';
import useScaledOrderCountInputHandlers from 'src/components/TradeForm/ScaledOrderCountInput/hooks/useScaledOrderCountInputHandlers';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

const PRESET_VALUES = [2, 3, 4, 5];

export default function useScaledOrderCountInput() {
	const orderCount = useVelocityStore(
		(s) => s.tradeForm.scaledOrders.orderCount
	);
	const isMobileScreenSize = useIsMobileScreenSize();

	const {
		customInputValue,
		currentValueSource,
		updateStateFromCustomInput,
		updateStateFromPreset,
		handleBlur,
		handleFocus,
		updateCustomInputValue,
	} = useCustomInputWithPresets({ currentValue: orderCount.toString() });

	const { handleCustomInputChange, handlePresetClick } =
		useScaledOrderCountInputHandlers({
			updateStateFromCustomInput,
			updateStateFromPreset,
			updateCustomInputValue,
		});

	const presetOptions = useMemo(() => {
		return [2, 3, 4, 5].map((i) => ({
			value: i,
			title: String(i),
		}));
	}, []);

	const newBrandPresetOptions = useMemo(() => {
		return PRESET_VALUES.map((value) => ({
			id: value.toString(),
			value: value.toString(),
			label: value.toString(),
			className: 'flex-1',
		}));
	}, []);

	return {
		currentValue: orderCount,
		presetOptions,
		newBrandPresetOptions,
		customInputValue,
		currentValueSource,
		handleBlur,
		handleFocus,
		handleCustomInputChange,
		handlePresetClick,
		isMobileScreenSize,
	};
}
